<template>
  <div id="app">
    <loading :active.sync="isLoading" :can-cancel="false" />
    <router-view />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import { mapGetters } from "vuex";

export default {
  components: {
    Loading
  },

  computed: {
    ...mapGetters({
      isLoading: "Spinner/isLoading"
    })
  }
};
</script>

<style>
/* Spinner style */
.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 1;
}

.vld-overlay.is-active {
  display: flex;
}

.vld-overlay.is-full-page {
  z-index: 999;
  position: fixed;
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}

.vld-overlay .vld-icon,
.vld-parent {
  position: relative;
}
/* Spinner style end */

/* for hiding background image */
.pg-wrapper.is-gather .slider .slider-items {
  background-image: none !important;
}
</style>
